// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_2n-6";
export var headerCell = "_2n-2";
export var loadingStateContent = "_2n-8";
export var rowWrapper = "_2n-4";
export var stickyAggregationCell = "_2n-b";
export var stickyAggregationRow = "_2n-7";
export var stickyColumnCell = "_2n-a";
export var stickyColumnHeaderCell = "_2n-9";
export var table = "_2n-1";
export var virtualRowWrapper = "_2n-5";
export var virtualTableContainer = "_2n-0";
export var white = "_2n-3";